import React, { FC, useState, useMemo } from "react";
import SearchInput from "./SearchInput";
import NoSearchResults from "./NoSearchResults";
import styles from "../../../styles/B2C/StepLayout.module.scss";
import gridStyles from "../../../styles/B2C/OptionGrid.module.scss";
import { useWizardOptions } from "../../../context/WizardOptionsContext";
import type { WizardCountryOption } from "../../../constants/onboardingFallbacks";

interface DestinationStepProps {
  selected: string[];
  onSelect: (countries: string[]) => void;
}

const DestinationStep: FC<DestinationStepProps> = ({ selected, onSelect }) => {
  const { countries } = useWizardOptions();
  const countryList = useMemo(() => countries ?? [], [countries]);

  const [search, setSearch] = useState("");

  const filteredCountries = useMemo(() => {
    if (!search.trim()) return countryList;
    return countryList.filter((country) =>
      country.name.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, countryList]);

  const handleSelect = (country: string) => {
    if (selected.includes(country)) {
      onSelect(selected);
    } else {
      onSelect([country]);
    }
  };

  return (
    <div className={styles.stepContent}>
      <SearchInput
        value={search}
        onChange={setSearch}
        placeholder="Search..."
      />
      {search.trim() !== "" && filteredCountries.length === 0 ? (
        <NoSearchResults />
      ) : (
        <div className={gridStyles.optionGridTall}>
          {filteredCountries.map((country: WizardCountryOption) => (
            <button
              key={country.name}
              type="button"
              title={country.name}
              className={`${gridStyles.optionItem} ${
                selected.includes(country.name) ? gridStyles.selected : ""
              }`}
              onClick={() => handleSelect(country.name)}
            >
              {country.imageUrl && (
                <img
                  src={country.imageUrl}
                  alt={country.imageAltTag || country.name}
                  style={{
                    width: 24,
                    height: 24,
                    marginRight: 8,
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
              )}
              <span className={gridStyles.optionLabel}>{country.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default DestinationStep;
